import { IPC_EVENT } from "../ipc_events";
import SaveTool from "./toolbar/save_tool";
import { store } from "../store";
import { TOOLS } from "./toolbar/tools";
import { mergeTask } from './record_task/task_store';
import { API_GET_USER_RECORD } from './api';
import TaskControl from './record_task/task_control';
import { RECORD_TASK_TYPE } from '../data/user_record/record_task_type';
import { useUserStore } from './user_data';
import BookData from './book_data';
import EventBus from "./event_bus";
import ImageControl from './record_task/image_control';
import { USER_RECORD_BUCKET } from './api/user_record';


export default class AppReceiver {
    static instance = null;
    static get Instance() {
        if (this._instance == null) {
            this._instance = new AppReceiver();
        }

        return this._instance;
    }
    renderer = null;
    constructor() {
        window.ipcRenderer.receive(IPC_EVENT.CHECK_LOG_NAME_REPEAT, (result) => {
            //result為-1表示未重複
            console.log("receive result:", result);

            //若本機無重複且要同步雲端，則也須檢查雲端格式(本機已重複則不需額外檢查雲端)
            if (result != -1 && result.status != "delete") {
                //本機有重複檔名
                SaveTool._instance.handleNameRepeatCheck(result);
            } else {
                if(store.mergeToCloud) {
                    //檢查雲端重複檔名，若有則替換result結果
                    const USER_DATA = useUserStore();
                    API_GET_USER_RECORD(BookData.Instance.BookId, USER_DATA.userId)
                        .then(response => {
                            return response.json();
                        }).then(data => {
                            var userRecordOnline = data.content.slice();
    
                            var i = 0;
                            for (i = 0; i < userRecordOnline.length; i++) {
                                if (userRecordOnline[i].log_name == store.nowLogName) {
                                    console.log("cloud result", userRecordOnline[i])
                                    result = {
                                        id: result == -1 ? null : result.id,
                                        status: userRecordOnline[i].save_staus
                                    }
                                    break;
                                }
                            }
    
                            //確認覆蓋視窗
                            SaveTool._instance.handleNameRepeatCheck(result);
                        });
                }else {
                    SaveTool._instance.handleNameRepeatCheck(result);
                }
            }
        });

        window.ipcRenderer.receive(IPC_EVENT.FINISH_SAVE, (result) => {
            // console.log("save finish::", result);
            if (store.mergeToCloud) {
                const USER_DATA = useUserStore();
                API_GET_USER_RECORD(BookData.Instance.BookId, USER_DATA.userId)
                    .then(response => {
                        return response.json();
                    }).then(async (data) => {
                        var userRecordOnline = data.content.slice();
                        var recordTask = {};
                        recordTask.taskName = result.content.log_name;
                        recordTask.taskType = RECORD_TASK_TYPE.UPLOAD_TO_CLOUD;
                        recordTask.updateTime = result.content.update_time;
                        recordTask.url = result.content.file_path;
                        var i = 0;
                        for (i = 0; i < userRecordOnline.length; i++) {
                            if (userRecordOnline[i].log_name == result.content.log_name) {
                                recordTask.log_id = userRecordOnline[i].log_id;
                                recordTask.taskType = RECORD_TASK_TYPE.UPDATE_TO_CLOUD;
                                recordTask.cloud_url = `${USER_RECORD_BUCKET}${userRecordOnline[i].uid}/${userRecordOnline[i].book_id}/${userRecordOnline[i].log_name}.json?t=${new Date().getTime()}`;
                                break;
                            }
                        }

                        const uploadTask = await TaskControl.Instance.uploadTask(recordTask);

                        if (uploadTask.success) {
                            SaveTool._instance.showFinish(uploadTask);
                        }

                    })

                return;
            }

            SaveTool._instance.showFinish(result.success);
        });

        window.ipcRenderer.receive(IPC_EVENT.GET_USER_RECORD, (result) => {
            SaveTool._instance.showUserRecord(result);
        })
        window.ipcRenderer.receive(IPC_EVENT.SWITCH_FULLSCREEN_WINDOW, (result) => {
            store.toggleTool[TOOLS.FULL_SCREEN.TOOL] = result;
        })
        window.ipcRenderer.receive(IPC_EVENT.SELECT_OTHER_RECORD, (filePath) => {
            console.log("select filePath:", filePath);
            this.renderer.loadRecord(filePath);
        });
        window.ipcRenderer.receive(IPC_EVENT.ADD_CLOUD_USER_RECORD_TO_LOCAL, (result, logName) => {
            // console.log("add cloud user record result: ", result);
            if (result) {
                mergeTask.setTaskResult(logName, "success");
            } else {
                mergeTask.setTaskResult(logName, "fail");
            }
        })
        window.ipcRenderer.receive(IPC_EVENT.UPDATE_CLOUD_USER_RECORD_TO_LOCAL, (result, logName) => {
            // console.log("add cloud user record result: ", result);
            if (result) {
                mergeTask.setTaskResult(logName, "success");
            } else {
                mergeTask.setTaskResult(logName, "fail");
            }
        })
        window.ipcRenderer.receive(IPC_EVENT.DELETE_USER_RECORD, (result, logName) => {
            if (result) {
                // console.log("刪除成功")
                mergeTask.setTaskResult(logName, "success");
            } else {
                mergeTask.setTaskResult(logName, "fail");
            }

            if (store.updateUserRecord) {
                store.updateUserRecord = false;
                this.renderer.getUserRecord();
            }
        })
        window.ipcRenderer.receive(IPC_EVENT.SINGLE_LOGIN, (title, account, county, token, userId) => {
            // console.log(title, account, county, token, userId)
            const USER_DATA = useUserStore();
            if (title != "TE") {
                //TODO: logout user, if title != TE
                var logout = window.open("https://oidc.tanet.edu.tw/oidc/v1/logout-to-go?id_token_hint=" + token + "&post_logout_redirect_uri=https://oidc.tanet.edu.tw/serviceclient", 'logout', config = "width=500 height=500 toolbar=0");
                setTimeout(function () {
                    logout.close();
                }, 1000);

                return;
            }

            USER_DATA.userId = userId;
            USER_DATA.userName = account;
            USER_DATA.token = token;

            this.renderer.finishSingleLogin();
        })
        window.ipcRenderer.receive(IPC_EVENT.GET_COPIED_IMAGE, (src, fileName) => {
            EventBus.getInstance().getAppRefs().insertPicture.setImage("file://" + src, fileName);

            ImageControl.Instance.addImage(fileName);
        })
        window.ipcRenderer.receive(IPC_EVENT.LOAD_RECORD, (data, path) => {
            SaveTool._instance.loadUserRecord(JSON.parse(data), path);
        })
    }
}